/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const dependencyItemCauseSummarySchema = z.object({
  atRiskPredecessors: z.array(z.int()),
  blockers: z.array(z.int()),
  cannotEvaluatePredecessors: z.array(z.int()),
  itemId: z.int(),
});
